<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <tab-nav :pills="true" class="iq-edit-profile d-flex pill-theme">
          <tab-nav-items
              :active="true"
              class="col-md-4 p-0"
              href="#workscheduleGlobal-tab"
          >
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <i aria-hidden="true" class="ri-calendar-event-fill"></i>
                {{
                  $t(
                      "public.components.workschedule.WorkSchedule.globalSchedule"
                  )
                }}
              </h4>
            </template>
          </tab-nav-items>
          <tab-nav-items
              :active="false"
              class="col-md-4 p-0"
              href="#workscheduleIpros-tab"
          >
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <i aria-hidden="true" class="ri-calendar-event-fill"></i>
                {{
                  $t(
                      "public.components.workschedule.WorkSchedule.iprosSchedule"
                  )
                }}
              </h4>
            </template>
          </tab-nav-items>
          <tab-nav-items
              :active="false"
              class="col-md-4 p-0"
              href="#workscheduleBlock-tab"
          >
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <i aria-hidden="true" class="ri-calendar-event-fill"></i>
                {{
                  $t(
                      "public.components.workschedule.WorkSchedule.lockableSchedule"
                  )
                }}
              </h4>
            </template>
          </tab-nav-items>
        </tab-nav>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <tab-content id="pills-tabContent-1">
          <tab-content-item id="workscheduleGlobal-tab" :active="true">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title title-typography-color">
                  <i aria-hidden="true" class="ri-calendar-event-fill"></i>
                  {{
                    $t(
                        "public.components.workschedule.WorkSchedule.globalSchedule"
                    )
                  }}
                </h4>
              </template>
              <template v-slot:headerAction>
                <b-button
                    class="float-right ml-2"
                    style="right"
                    variant="success"
                    @click="createGlobal"
                >{{
                    $t("public.components.workschedule.WorkSchedule.btnSelect")
                  }}
                </b-button
                >
              </template>
              <template v-slot:body>
                <WorkscheduleGlobal
                    ref="workscheduleGlobalRef"
                    :idProfessional="idProfessional"
                    :updateDataComponets="updateDataComponets"
                ></WorkscheduleGlobal>
              </template>
            </iq-card>
          </tab-content-item>
          <tab-content-item id="workscheduleIpros-tab" :active="false">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title title-typography-color">
                  <i aria-hidden="true" class="ri-calendar-event-fill"></i>
                  {{
                    $t(
                        "public.components.workschedule.WorkSchedule.iprosSchedule"
                    )
                  }}
                </h4>
              </template>
              <template v-slot:headerAction>
                <b-button
                    class="float-right ml-2"
                    style="right"
                    variant="success"
                    @click="updateDuration"
                >{{
                    $t(
                        "public.components.workschedule.WorkSchedule.btnDuration"
                    )
                  }}
                </b-button
                >
              </template>
              <template v-slot:body>
                <WorkscheduleIpros
                    ref="workscheduleIprosRef"
                    :idProfessional="idProfessional"
                    :updateDataComponets="updateDataComponets"
                ></WorkscheduleIpros>
              </template>
            </iq-card>
          </tab-content-item>
          <tab-content-item id="workscheduleBlock-tab" :active="false">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title title-typography-color">
                  <i aria-hidden="true" class="ri-calendar-event-fill"></i>
                  {{
                    $t(
                        "public.components.workschedule.WorkSchedule.lockableSchedule"
                    )
                  }}
                </h4>
              </template>
              <template v-slot:headerAction>
                <b-button
                    class="float-right ml-2"
                    style="right"
                    variant="success"
                    @click="createBlock"
                >{{
                    $t("public.components.workschedule.WorkSchedule.btnSeason")
                  }}
                </b-button
                >
              </template>
              <template v-slot:body>
                <WorkscheduleBlock
                    ref="workscheduleBlockRef"
                    :idProfessional="idProfessional"
                    :updateDataComponets="updateDataComponets"
                ></WorkscheduleBlock>
              </template>
            </iq-card>
          </tab-content-item>
        </tab-content>
      </b-col>
    </b-row>
    <notifications group="notificacions"/>
  </b-container>
</template>
<script>
import {xray} from "../../config/pluginInit";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import WorkscheduleGlobal from "../../components/workschedule/WorkscheduleGlobal";
import WorkscheduleIpros from "../../components/workschedule/WorkscheduleIpros";
import WorkscheduleBlock from "../../components/workschedule/WorkscheduleBlock";

export default {
  name: "Workschedule",
  props: ["idProfessional"],
  mounted() {
    xray.index();
  },
  computed: {},
  methods: {
    updateDataComponets() {
      this.$refs.workscheduleGlobalRef.getAllSchedules();
      this.$refs.workscheduleIprosRef.getWorkschedule();
      this.$refs.workscheduleBlockRef.getAllSeasons();
    },
    // Global
    createGlobal() {
      this.$refs.workscheduleGlobalRef.openModalSchedule("create", "");
    },
    // Ipros
    updateDuration() {
      this.$refs.workscheduleIprosRef.openModalSchedule("create", "");
    },
    // Block
    createBlock() {
      this.$refs.workscheduleBlockRef.openModalSchedule("create", "");
    },
  },
  data() {
    return {
      idProfessional: localStorage.getItem("userId"),
    };
  },
  components: {
    WorkscheduleGlobal,
    WorkscheduleIpros,
    WorkscheduleBlock,
    Multiselect,
  },
};
</script>